import metadefenderCloudGlyph from 'images/metadefender-cloud-glyph.svg';

export const Logo = () => (
    <div className='tw:flex tw:items-center tw:gap-8' data-testid='product-logo'>
        <img src={metadefenderCloudGlyph} alt='' aria-hidden='true' className='tw:h-24 tw:w-auto' />
        <span className='tw:flex tw:flex-col tw:leading-none'>
            <span className='tw:text-body tw:font-bold tw:uppercase tw:tracking-wide tw:text-neutrals-1000 tw:dark:text-neutrals-100'>
                MetaDefender
            </span>
            <span className='tw:text-sm tw:text-neutrals-700 tw:dark:text-neutrals-400'>Cloud</span>
        </span>
    </div>
);
